import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlockStyled from './Block.styled';
import Path from '../Path/Path';
import {
  onBlockSelected,
  onBlockTargeted,
} from '../../../state-actions/onBlockSelections';
import IconSelected from '../IconSelected/IconSelected';

const mapStateToProps = state => ({
  blockSelected: state.blockSelected,
  blockTargeted: state.blockTargeted,
  correctBlockOrder: state.correctBlockOrder,
  started: state.game.started,
});
const mapDispatchToProps = dispatch => ({
  onBlockSelected: target => dispatch(onBlockSelected(target)),
  onBlockTargeted: target => dispatch(onBlockTargeted(target)),
});

export const Block = ({ ready, block, started, orderID, offset, ...props }) => {
  const {
    blockSelected,
    blockTargeted,
    onBlockSelected,
    onBlockTargeted,
    roundWin,
  } = props;

  const handleBlockSelected = e => {
    if (roundWin || !started) return;
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
      if (blockSelected.orderID == null) {
        onBlockSelected({ orderID, offset });
      } else if (blockSelected.orderID === orderID) {
        onBlockSelected({}); // reset
      } else {
        onBlockTargeted({ orderID, offset });
      }
    }
  };

  const checkStartTransition = blockID => {
    if (Object.keys(blockTargeted).length) {
      if (
        blockID === blockTargeted.orderID ||
        blockID === blockSelected.orderID
      )
        return true;
    }
    return false;
  };

  return (
    <BlockStyled
      tabIndex="0"
      id={process.env.NODE_ENV === 'production' ? `block${orderID}` : block}
      role="button"
      changeStart={checkStartTransition(orderID)}
      onKeyDown={handleBlockSelected}
      onClick={handleBlockSelected}
      ready={ready}
      blockOffsetPos={block}
      orderOnPage={orderID}
      select={!roundWin && orderID === blockSelected.orderID}
      selected={blockSelected.orderID}
      className={`${!roundWin &&
        orderID === blockSelected.orderID &&
        'selected'} ${!started && 'disabled'} ${roundWin && 'round-win'}`}
    >
      {!roundWin && (
        <IconSelected
          showHover={blockSelected}
          selected={!roundWin && orderID === blockSelected.orderID}
        />
      )}
      <Path />
    </BlockStyled>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Block);

Block.propTypes = {
  block: PropTypes.string.isRequired,
  orderID: PropTypes.number.isRequired,
  offset: PropTypes.number.isRequired,
  ready: PropTypes.bool.isRequired,
  roundWin: PropTypes.bool,
  blockSelected: PropTypes.objectOf(PropTypes.number),
  blockTargeted: PropTypes.objectOf(PropTypes.number),
  started: PropTypes.bool.isRequired,
};

Block.defaultProps = {
  blockSelected: {},
  blockTargeted: {},
  roundWin: false,
};



// WEBPACK FOOTER //
// ./src/components/atoms/Block/Block.js